// extracted by mini-css-extract-plugin
export default {"tag":"_","tags":"aa","blinking":"ba"};